module.exports = __webpack_public_path__ + "img/monitoring.5cb780fe.svg";